import React from 'react'
import { LayoutBand, H3, Overline, Subheading, Button, Separator, Grid, Cell, usePageWidth, Image } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { Link } from '@fs/zion-router'
import familyTreeImage from './images/family-tree-image.png'

export default function FamilyTree() {
  const { t } = useTranslation()
  const atPageWidth = usePageWidth()
  const isMobile = atPageWidth({ default: true, md: false })
  return (
    <LayoutBand marginX="xl">
      <Grid alignItemsY="middle">
        {isMobile && <FamilyTreeImage columns={atPageWidth({ default: 12, md: 5, xl: 7 })} />}
        <Cell columns={atPageWidth({ default: 12, md: 6, xl: 4 })}>
          <H3 size="H5">
            <Overline>{t('nlihp.united-states.family-tree.overline', 'Family Tree')}</Overline>
            {t('nlihp.united-states.family-tree.heading', 'Build the branches of your own family tree')}
            <Subheading>
              {t(
                'nlihp.united-states.family-tree.subheading',
                "The automated tree builder will guide you along. As you ad information, we'll search for ancestor connections."
              )}
            </Subheading>
          </H3>
          <Separator size="xs" />
          <Button
            emphasis="medium"
            external
            to="/tree/guided/connect-to-tree"
            color="gray"
            linkName="Start your tree"
            target="_blank"
          >
            {t('nlihp.united-states.family-tree.start-your-tree', 'Start your tree')}
          </Button>
          <Separator size="xs" />
          <Link external to="/family-tree" isGray wayfinding linkName="More about Family Tree" target="_blank">
            {t('nlihp.united-states.family-tree.more-about-tree', 'More about Family Tree')}
          </Link>
        </Cell>
        {!isMobile && (
          <Cell columns={atPageWidth({ default: 0, md: 1 })}>
            <div />
          </Cell>
        )}
        {!isMobile && <FamilyTreeImage columns={atPageWidth({ default: 12, md: 5, xl: 7 })} />}
      </Grid>
      <Separator size={atPageWidth({ default: 'xxl', lg: 'xl' })} />
    </LayoutBand>
  )
}

function FamilyTreeImage() {
  const { t } = useTranslation()
  return (
    <Image
      src={familyTreeImage}
      alt={t('nlihp.united-states.family-tree.image-alt-text', 'Screenshots of tree building onboarding experience')}
      maxHeight={868}
      noCrop
    />
  )
}
